module.exports = __webpack_public_path__ + "img/icon-1_14.4aca530b.png";